'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Pricement;
(function (Pricement) {
    var MyPricement = /** @class */ (function () {
        function MyPricement() {
            var self = this;
            $(document).ready(function () {
                $('.trigPriceTable').click(function () {
                    var openFlag = $('.paramPriceTable').attr('data-show');
                    if (openFlag == 'close') {
                        $('.bulletPriceTable').attr('data-show', 'open');
                    }
                    else {
                        $('.bulletPriceTable').attr('data-show', 'close');
                    }
                });
                $('.trigOptionTable').click(function () {
                    var openFlag = $('.paramOptionTable').attr('data-show');
                    if (openFlag == 'close') {
                        $('.bulletOptionTable').attr('data-show', 'open');
                    }
                    else {
                        $('.bulletOptionTable').attr('data-show', 'close');
                    }
                });
            });
        }
        return MyPricement;
    }());
    Pricement.MyPricement = MyPricement;
})(Pricement || (Pricement = {}));
exports.default = Pricement;
